import { Button, Card, Row } from "antd";
import { useCallback, useState } from "react";
import { RequestsModal } from "./components/RequestsModal";

type RequestsProps = {
  contractNumber: string;
};

export const Requests = ({ contractNumber }: RequestsProps) => {
  const [open, setOpen] = useState<boolean>(false);

  const openModal = useCallback(() => setOpen(true), []);

  return (
    <Card className="mx-4 mb-4 w-100">
      <Row className="d-block mb-6">
        <h4 className="h h4 mb-1">Payoff Quote</h4>
        <p className="text-md title mt-0">
          Total amount typically includes principal balance, interest through
          payoff date, and other fees.
        </p>
      </Row>
      <Button size="large" shape="round" onClick={openModal}>
        Request Quote
      </Button>

      <RequestsModal
        open={open}
        setOpen={setOpen}
        contractNumber={contractNumber}
      />
    </Card>
  );
};
